var f = Object.defineProperty, p = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var s = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var a = (r, e, o) => e in r ? f(r, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[e] = o, m = (r, e) => {
  for (var o in e || (e = {}))
    s.call(e, o) && a(r, o, e[o]);
  if (t)
    for (var o of t(e))
      n.call(e, o) && a(r, o, e[o]);
  return r;
}, i = (r, e) => p(r, c(e));
import x, { forwardRef as d } from "react";
import l from "../lib/IconBase.mjs";
import w from "../defs/GearSix.mjs";
const G = d((r, e) => /* @__PURE__ */ x.createElement(l, i(m({ ref: e }, r), { weights: w })));
G.displayName = "GearSix";
export {
  G as GearSix
};
